var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('workforce-search-input',{attrs:{"value":_vm.searchInput,"isSearchingResults":_vm.processing,"categorySearchResults":_vm.searchResults},on:{"input":_vm.onSearch,"category-change":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }